import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";

import {
  Box,
  FormControl,
  Grid,
  IconButton,
  Button as UploadButton
} from "@mui/material";
import moment from "moment";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";

import AuthService from "../../Components/auth/AuthService";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import ScanDialog from "../../Components/common/ScanDialog";
import ActionButtons from "../../Components/common/ActionButtons";
import Message from "../../Components/common/Message";
import { Table, Button as AntButton, Input, Flex, message, Row, Col, Modal, Typography, Divider, Descriptions, Tag, Image, Tooltip, Checkbox, Select as AntSelect, Alert, Space } from "antd";
import { ArrowLeftOutlined, BarcodeOutlined, CalendarOutlined, DeleteFilled, ExportOutlined, InfoCircleFilled, InfoCircleOutlined, InfoCircleTwoTone, NumberOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ScanInput from "../Scan/ScanInput";
import { set } from "lodash";
import { env, wms_uploads_cdn } from "../../Components/config";
import ScanSelect from "../Scan/ScanSelect";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";
import { extractOriginalFileName, getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from "../../Components/common/CommonFun";
import './dashboard.css'
import ProductInfoModal from "../../Components/Modals/ProductInfoModal";
import ProductScanSelect from "../Scan/ProductScanSelect";
import CustomTag from "../../Components/CustomTag";
import InfoCards from "../../Components/InfoCards";
import DetailsGrid from "../../Components/common/DetailsGrid";
const DispatchStock = () => {
  const { locations, products } = useSelector((state) => state?.AppState?.userCreds);
  const { Text } = Typography;
  const { Option } = AntSelect;
  const { TextArea } = Input;
  let layoutDispatch = useLoadingDispatch();
  const Auth = new AuthService();
  const navigate = useNavigate()
  const [soNumber, setSoNumber] = useState("");
  const [recievedData, setRecievedData] = useState([]);
  const [transRecords, setTransRecords] = useState([]);
  const [info, setInfo] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [allTransactionsModalVisible, setAllTransactionsModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [dispatchStock, setDispatchStock] = useState({
    product: "",
    product_id: '',
    location: "",
    location_id: null,
    quantity: "",
    productText: '',
    locationText: '',
    productStatus: null,
    locationStatus: null,
    batch_id: null,
    batch_expiry: null,
    batch_quantity: '',
    batch_code: '',
    supplier_batch_code: '',
    remaining_quantity_check: false,
    fullPallet: false,
    fullPalletShow: false,
    remainQtyShow: false,
  });

  const [selectedProductLocations, setSelectedProductLocations] = useState([])
  const [selectedLocationsBatches, setSelectedLocationBatches] = useState([])
  const [stockTransactions, setStockTransactions] = useState([])
  const [posted, setPosted] = useState(false);
  const [postedAt, setPostedAt] = useState(null);

  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [notes, setNotes] = useState("");
  const productRef = useRef(null);
  useEffect(() => {
    if (modalVisible) {
      setTimeout(() => {
        productRef.current?.focus();
      }, 100);
    }
  }, [modalVisible]);

  const submitImage = (e) => {
    handleSubmitImage(e, setFiles, setCurrentItemFiles)
  }

  const handleValueChange = (value, isScanned) => {
    setSoNumber(value);
    if (isScanned) {
      handleSearch();
    }
  };

  const handleSelect = async (record) => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/stock/dispatched-stock?transaction_id=${record?.internal_id}&product_netsuite_id=${record?.product_netsuite_id}`);
      if (res?.ack) {
        const totalQuantityAdded = res?.stock_txns.reduce((sum, txn) => sum + (txn.quantity || 0), 0);
        const currentItemID = res?.stock_txns[0]?.product_netsuite_id;
        const updatedRemainingQty = record?.fulfilled_quantity - totalQuantityAdded;
        const updatedRecord = { ...record, remaining_quantity: updatedRemainingQty };
        const updatedReceivedData = recievedData.map(item => {
          if (item.product_netsuite_id === currentItemID) {
            return { ...item, remaining_quantity: updatedRemainingQty, dispatched_quantity: totalQuantityAdded };
          }
          return item;
        });
        const selectedProduct = products?.find((pro) => pro?.netsuite_id == record?.product_netsuite_id);
        const selectedProductCasesInPallets = selectedProduct?.cases_in_pallets
        const capacityStaus = updatedRemainingQty >= selectedProductCasesInPallets ? true : false;
        if (capacityStaus) {
          setDispatchStock({ ...dispatchStock, fullPalletShow: true, remainQtyShow: false })
        } else {
          setDispatchStock({ ...dispatchStock, fullPalletShow: false, remainQtyShow: true })
        }
        setStockTransactions(res?.stock_txns)
        setSelectedItem(updatedRecord);
        setRecievedData(updatedReceivedData)
        setModalVisible(true);
      } else {
        showMessage('error', res?.message)
        setStockTransactions([])
      }
    } catch (err) {
      showMessage('error', 'something went wrong')
      setStockTransactions([])
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const productValueChange = (value) => {
    setDispatchStock({ ...dispatchStock, product: value });
  };
  const locationValueChange = (value) => {
    setDispatchStock({ ...dispatchStock, location: value });

  };

  const handleModalOk = async () => {
    if (!dispatchStock?.product_id || !dispatchStock?.location_id || !dispatchStock?.quantity) {
      showMessage('error', 'Fill all required fields')
      return;
    }
    const dataToSend = {
      product_netsuite_id: dispatchStock?.product_id,
      location_id: dispatchStock?.location_id,
      quantity: dispatchStock?.quantity,
      netsuite_transaction_id: selectedItem?.internal_id,
      purchase_order_details_batch_id: dispatchStock?.batch_id,
      batch_code: dispatchStock?.batch_code,
      expiry_date: dispatchStock?.batch_expiry,
      supplier_batch_code: dispatchStock?.supplier_batch_code,
      order_detail_id: selectedItem?.order_detail_id
    };
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch('/stock/dispatch-stock ', {
        method: 'POST',
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        showMessage('success', res?.message)
        setRecievedData(prevItems =>
          prevItems.map(item => {
            if (item.product_code === selectedItem.product_code) {
              const newRem = selectedItem?.remaining_quantity - Number(dispatchStock?.quantity)
              const newDispatchedQTY = Number(item.dispatched_quantity) + Number(dispatchStock?.quantity)
              return { ...item, dispatched_quantity: newDispatchedQTY, remaining_quantity: newRem };
            }
            return item;
          })
        );
        setDispatchStock({ product: "", product_id: '', location: "", location_id: null, quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, remainQtyShow: false, fullPalletShow: false })
        setModalVisible(false);
        setSelectedProductLocations([])
        setSelectedLocationBatches([])
        setSelectedItem(null)
        // handleSearch()
      } else {
        showMessage('error', res?.message)
        hideLoading(layoutDispatch)

      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      hideLoading(layoutDispatch)

    }
    finally {
      hideLoading(layoutDispatch)
    }

  };

  const handleModalCancel = () => {
    setDispatchStock({ product: "", product_id: '', location: "", location_id: null, quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, remainQtyShow: false, fullPalletShow: false })
    setSelectedProductLocations([])
    setSelectedLocationBatches([])
    setModalVisible(false);

  };

  const locationBlur = () => {
    if (!dispatchStock?.product_id) {
      showMessage('error', 'Please select a product first')
      setDispatchStock({ ...dispatchStock, location: '' })
      return;
    }
    const selectedProduct = products?.find((pro) => pro?.netsuite_id == dispatchStock?.product_id)
    const productLocations = selectedProduct?.product_locations
      ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
      : [];
    if (!dispatchStock?.location) {
      setDispatchStock({ ...dispatchStock, locationStatus: 'error', locationText: 'No Location Entered' })
      return;
    } else {
      const selectedLocation = locations?.find((loc) => loc?.code == dispatchStock?.location)
      if (selectedLocation?.id && productLocations?.includes(selectedLocation?.id)) {


        setDispatchStock({ ...dispatchStock, location_id: selectedLocation?.id, locationStatus: 'success', locationText: selectedLocation?.title })
      } else {
        setDispatchStock({ ...dispatchStock, locationStatus: 'error', locationText: 'Location not found' })
      }

    }
  };

  const productBlur = () => {
    if (!dispatchStock?.product_id) {
      setDispatchStock({ ...dispatchStock, productStatus: 'error', productText: 'No Product Entered' })
      return;
    } else {
      const selectedProduct = products?.find((pro) => pro?.code == dispatchStock?.product || pro?.barcode == dispatchStock?.product);
      const matchedProduct = selectedItem?.product_netsuite_id == selectedProduct?.netsuite_id ? true : false;

      console.log('selectedProduct', selectedProduct);

      const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
      const matchedLocations = locations.filter(location =>
        productLocations.includes(location.id)
      );

      if (selectedProduct && matchedProduct) {
        if (selectedProduct?.netsuite_id != selectedItem?.product_netsuite_id) {
          setDispatchStock({ ...dispatchStock, productStatus: 'error', productText: 'Wrong product selected', product: '', product_id: null })
        } else {
          setSelectedProductLocations(matchedLocations);

          setDispatchStock({ ...dispatchStock, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name })
        }
      } else {
        setDispatchStock({ ...dispatchStock, productStatus: 'error', productText: 'Invalid Product ', product: '', product_id: null })
      }

    }
  };

  const getProductLocations = async (product_id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product-location/location-stock-by-product-batches?id=${product_id}`)
      if (res?.ack) {
        const resLocations = res?.product_location || [];

        const matchedLocations = locations
          ?.map(loc => {
            const matchedRes = resLocations.find(r => r.location_id === loc.id);
            if (matchedRes) {
              return {
                ...loc,
                quantity: matchedRes.quantity || 0, // push quantity from response
              };
            }
            return null;
          })
          .filter(Boolean) // remove unmatched
          .sort((a, b) => (b.is_picking || 0) - (a.is_picking || 0)); // sort by is_picking


        setSelectedProductLocations(matchedLocations || []);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      showMessage('error', 'Something went wrong');
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  const productSelectValueChange = (val, isScanned) => {
    console.log('productSelectValueChange', val, isScanned);

    const selectedProduct = isScanned
      ? products?.find((pro) => pro?.code === val || pro?.barcode === val)
      : products?.find((pro) => pro?.netsuite_id === val);

    const matchedProduct = selectedItem?.product_netsuite_id === selectedProduct?.netsuite_id;

    if (selectedProduct && matchedProduct) {
      const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
      const matchedLocations = locations.filter(location =>
        productLocations.includes(location.id)
      );
      setDispatchStock({ ...dispatchStock, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name })
      // setSelectedProductLocations(matchedLocations);
      getProductLocations(selectedProduct?.netsuite_id)

    } else {
      setDispatchStock({ ...dispatchStock, productStatus: 'error', productText: 'Invalid Product', product: '', product_id: '', location_id: null });
      showMessage('error', 'Invalid Product Selected');
    }
  };

  const locationSelectValueChange = (val, isScanned) => {
    console.log('locationSelectValueChange', val, isScanned);
    if (!dispatchStock?.product_id) {
      showMessage('error', 'Please select a product first')
      setDispatchStock({ ...dispatchStock, location_id: null, batch_id: null, batch_code: '', batch_expiry: null, batch_quantity: '', supplier_batch_code: '' })
      return;
    }
    if (isScanned) {
      const matched = selectedProductLocations?.find(item => item.code === val);
      if (matched) {
        setDispatchStock({ ...dispatchStock, location_id: matched.id, batch_id: null, batch_code: '', batch_expiry: null, batch_quantity: '', supplier_batch_code: '' });
        getLocationBatches(matched?.id, dispatchStock?.product_id)
      } else {
        showMessage('error', "No matching location");
      }
    } else {
      setDispatchStock({ ...dispatchStock, location_id: val, batch_id: null, batch_code: '', batch_expiry: null, batch_quantity: '', supplier_batch_code: '' });
      getLocationBatches(val, dispatchStock?.product_id)

    }
  };

  //============Get Scan Value
  const handlePOScanValue = (value) => {
    setSoNumber(value);
  };

  const handleSearch = async () => {
    showLoading(layoutDispatch);
    setTransRecords([])
    setRecievedData([])
    setInfo(null);
    try {
      const res = await Auth.fetch(`/ns/get-sales-order?id=${soNumber}`);
      if (res.ack) {
        // setInfo(res?.order)
        const updatedItems = res?.order?.map((item) => {
          const fulfilled = Number(item?.fulfilled_quantity) || 0;
          const dispatched = Number(item?.dispatched_quantity) || 0;

          return {
            ...item,
            remaining_quantity: fulfilled - dispatched
          };
        });

        setRecievedData(updatedItems);
        setNotes(res?.order[0]?.notes)
        setCurrentItemFiles(res?.order[0]?.files ? JSON.parse(res?.order[0]?.files) : [])
        setPosted(res?.order[0].posted_by > 0 ? true : false);
        setPostedAt(res?.order[0].posted_at);
      } else {
        showMessage('error', 'Data not found, Only collection orders can be dispatched');
        setInfo(res)
        setRecievedData([]);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', "Something went wrong");

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const postStockData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      id: recievedData[0]?.id,
      notes: notes,
      files: currentItemFiles ? currentItemFiles : [],
    }
    try {
      const res = await Auth.fetch(`/stock/post-so-stock`, {
        method: "POST",
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success', res?.message);
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, 'dispatch-stock', soNumber)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);
        // handleSearch()
        fetchUpdatedDetails()
        // navigate("/stocks");
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);

      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      hideLoading(layoutDispatch);

    }
    //  finally {
    //   hideLoading(layoutDispatch);
    // }
  };

  const fetchUpdatedDetails = async () => {
    showLoading(layoutDispatch);
    setNotes('')
    setFiles([])
    setCurrentItemFiles([])
    try {
      const res = await Auth.fetch(`/stock/sales-order-details?id=${recievedData[0]?.id}`);
      if (res?.ack) {
        setNotes(res?.sales_order[0]?.notes)
        setCurrentItemFiles(res?.sales_order[0]?.files ? JSON.parse(res?.sales_order[0]?.files) : [])
        setPosted(res?.sales_order[0].posted_by > 0 ? true : false);
        setPostedAt(res?.sales_order[0].posted_at)
      } else {
        showMessage('error', res?.message);
        // hideLoading(layoutDispatch);
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      // hideLoading(layoutDispatch);

    }
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const saveStockData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      id: recievedData[0]?.id,
      notes: notes,
      files: currentItemFiles ? currentItemFiles : [],
    }
    try {
      const res = await Auth.fetch(`/stock/save-so-stock`, {
        method: "POST",
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success', res?.message);
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, 'dispatch-stock', soNumber)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);
        fetchUpdatedDetails()
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);

      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      hideLoading(layoutDispatch);

    }
    //  finally {
    //   hideLoading(layoutDispatch);
    // }
  };

  const getNewStockQty = async (transactionId, allItems) => {
    if (!transactionId) {
      hideLoading(layoutDispatch)
      return;
    };
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/dispatched-stock?id=${transactionId}`);
      if (res?.ack) {
        console.log(res, 'Stock');

        if (res?.stock_txns.length > 0) {
          setTransRecords(res?.stock_txns)
          const stockData = res.stock_txns.reduce((acc, stockItem) => {
            const productId = Number(stockItem.product_netsuite_id);

            if (!acc[productId]) {
              acc[productId] = { quantity: 0, stockTxns: [] };
            }

            acc[productId].quantity += stockItem.quantity;
            acc[productId].stockTxns.push(stockItem);

            return acc;
          }, {});

          const updatedItems = allItems.map((item) => {
            const productId = Number(item.itemId);
            return {
              ...item,
              quantityDispatched: stockData[productId]?.quantity || 0,
              quantityRemaining: Number(item.quantityFulfilled) - (stockData[productId]?.quantity || 0),
              stock_transaction: stockData[productId]?.stockTxns || []
            };
          });

          setRecievedData(updatedItems ?? []);
        } else {
          const updatedItems = allItems.map((item) => {
            return {
              ...item,
              quantityRemaining: Number(item.quantityFulfilled) || 0,
            };
          });
          // setRecievedData(allItems ?? []);
          setRecievedData(updatedItems ?? []);
        }
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  console.log('recievedData', recievedData);

  const deleteTransaction = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/delete-so-transaction`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        showMessage('success', res?.message);
        const deletedItem = stockTransactions?.find(item => item.id == id);
        const updatedReceivedData = recievedData?.map(item => {
          if (item.product_netsuite_id === deletedItem?.product_netsuite_id) {
            const newRem = item?.remaining_quantity + Number(deletedItem?.quantity)
            const newDispatchedQTY = Number(item.dispatched_quantity) - Number(deletedItem?.quantity)
            return { ...item, dispatched_quantity: newDispatchedQTY, remaining_quantity: newRem };
          }
          return item;
        });
        setRecievedData(updatedReceivedData)
        setModalVisible(false);
        setSelectedItem(null);

        // handleSearch();
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    }
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const getLocationBatches = async (location_id, product_id) => {
    setSelectedLocationBatches([]);
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/location-batches?location_id=${location_id}&product_netsuite_id=${product_id}`);
      if (res?.ack) {
        setSelectedLocationBatches(res?.location_batches)

      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  // const checkQTyRemaingAllItems = () => {
  //   const allItems = recievedData?.filter((item) => item?.itemName != "Delivery Charge")
  //   const allQtyRemaining = allItems?.every((item) => item?.quantityRemaining == 0);
  //   return allQtyRemaining;
  // }

  const areAllItemQuantitiesZero = (
    recievedData?.every((item) => item?.remaining_quantity == 0)) || false;

  // const notZeroProductCodes = recievedData
  // ?.filter(item => Number(item?.remaining_quantity) !== 0)
  // .map(item => item?.product_code) || [];
  const notZeroProductCodes = recievedData?.reduce((acc, item, index) => {
    if (Number(item?.remaining_quantity) !== 0) {
      acc.push({ product_index: index + 1, product_code: item?.product_code });
    }
    return acc;
  }, []) || [];



  console.log('areAllItemQuantitiesZero', areAllItemQuantitiesZero);

  const [selectedProductDetails, setSelectedProductDetails] = useState({
    totalStock: 0,
    code: '',
    name: '',
    productDetails: []
  })
  const [modalVisibleProduct, setModalVisibleProduct] = useState(false);

  const handleModalCancelProduct = () => {
    setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, product: null, productDetails: [] });
    setModalVisibleProduct(false);
  }
  const handleInfoClick = async (record) => {
    const product = products?.find((item) => item?.netsuite_id == record?.product_netsuite_id);
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/product/product-details?id=${record?.product_netsuite_id}`)
      if (res?.ack) {
        if (res?.product_details.length > 0) {
          const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
          setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details });
          setModalVisibleProduct(true);
          hideLoading(layoutDispatch)

        } else {
          showMessage('error', 'No Details');
          hideLoading(layoutDispatch)
        }
      } else {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
        showMessage('error', res?.message)
        hideLoading(layoutDispatch)

      }

    } catch (error) {
      showMessage('error', 'something went wrong');
      hideLoading(layoutDispatch)
    }
  };


  const dataCol = [
    {
      title: "Sr No.",
      render: (_, __, index) => <span>{index + 1}</span>,
      width: 60,
    },
    {
      title: "Item",
      width: 220,
      sorter: (a, b) => (a?.product_name || "").localeCompare(b?.product_name || ""),
      render(record) {

        return (
          <Flex gap={5} align="center">
            <Tooltip title={'Product Info'}>

              <InfoCircleTwoTone style={{ fontSize: '22px', cursor: 'pointer' }} onClick={() => handleInfoClick(record)}
              />
            </Tooltip>
            {/* <span>{record?.product_name}</span> */}
            <Tooltip title={record?.product_name}>
              <span
                style={{
                  maxWidth: 200,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'inline-block',
                }}
              >
                {record?.product_name}
              </span>
            </Tooltip>

          </Flex>
        )

      }
    },
    // {
    //   title: "Category",
    //   render: (record) => {
    //     const item = products?.find((item) => item.netsuite_id == record?.itemId);
    //     return (
    //       <span>{item?.category ? item?.category : '-'}</span>
    //     )
    //   }
    // },
    {
      title: "Category",
      sorter: (a, b) => {
        const catA =
          products?.find((item) => item.netsuite_id == a?.product_netsuite_id)
            ?.sub_category || "";
        const catB =
          products?.find((item) => item.netsuite_id == b?.product_netsuite_id)
            ?.sub_category || "";
        return catA.localeCompare(catB);
      },
      render: (record) => {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
        return (
          <span>{item?.sub_category ? item?.sub_category : '-'}</span>
        )
      }
    },
    {
      title: 'Fulfilled Qty',
      dataIndex: 'fulfilled_quantity',
      key: 'fulfilled_quantity',
      align: 'center',
      sorter: (a, b) => (a.fulfilled_quantity || 0) - (b.fulfilled_quantity || 0),
      render: (fulfilled_quantity) => {
        return <span>{fulfilled_quantity?.toLocaleString() || '0'}</span>;
      },
    },
    {
      title: 'Dispatched Qty',
      // dataIndex: 'dispatched_quantity',
      // key: 'dispatched_quantity',
      align: 'center',
      sorter: (a, b) =>
        (a.dispatched_quantity || 0) - (b.dispatched_quantity || 0),
      render: (record) => {
        return <Tag color={record?.dispatched_quantity <= record?.fulfilled_quantity ? 'red' : 'blue'} style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.dispatched_quantity)?.toLocaleString() || 0} </Tag>;
      },
    },
    {
      title: 'Remaining Qty',
      align: 'center',
      sorter: (a, b) => (a.remaining_quantity || 0) - (b.remaining_quantity || 0),
      render: (record) => {
        return (
          // <span>{record?.remaining_quantity}</span>
          <Tag color={record?.remaining_quantity > 0 ? 'red' : 'blue'} style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.remaining_quantity}</Tag>
        );
      },
    },
    // {
    //   title: "Action", align: "center", render: (record) => (
    //     <AntButton type="primary" onClick={() => handleSelect(record)} disabled={record?.itemName == "Delivery Charge"}>
    //       Select
    //     </AntButton>
    //   ),
    // },
    {
      title: "Action",
      align: "center",
      render: (record) => (
        <Tooltip title="Select Item">
          <ExportOutlined
            className="animated-select-icon"
            onClick={() => handleSelect(record)}
            disabled={record?.itemName == "Delivery Charge"}
          />
        </Tooltip>
      ),
    }

  ];

  const stockTxnsCol = [
    {
      title: 'Location',
      render(record) {
        const selectedlocation = locations?.find((loc) => loc?.id == record?.location_id)
        return (
          <>{selectedlocation?.code}</>
        );
      }
    },
    {
      title: 'Batch Code',
      render(record) {
        return (
          <>{record?.batch_code}</>
        );
      }
    },
    {
      title: 'Supplier Batch Code',
      render(record) {
        return (
          <>{record?.supplier_batch_code || ''}</>
        );
      }
    },
    {
      title: 'Quantity',
      render(record) {
        return (
          <span style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.quantity)?.toLocaleString() || 0} </span>
        );
      }
    },
    {
      title: "User",
      render(record) {
        if (!record) return "";

        const user = record?.user_name || "";
        const helper = record?.helper_name || "";

        if (helper) {
          return (
            <>
              {helper}{" "}
              {user && (
                <Tooltip title={`${user}`}>
                  <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                </Tooltip>
              )}
            </>
          );
        }

        return <>{user}</>;
      }
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => moment(date).format("YYYY-MM-DD HH:mm:ss"),
    },
    // {
    //   title: 'Action',
    //   align: "right",
    //   dataIndex: '',
    //   render(record) {
    //     return (
    //       <div style={{ display: "flex", justifyContent: "flex-end" }}>
    //         <DeleteFilled style={
    //           {
    //             fontSize: "25px",
    //             cursor: "pointer",
    //             color: "#cd1437",
    //           }} onClick={() => {
    //             Modal.confirm({
    //               title: 'Delete Transaction',
    //               centered: true,
    //               content: `Are you sure you want to delete this transaction?`,
    //               onOk: () => deleteTransaction(record.id),
    //               okText: 'Delete',
    //               cancelText: 'Cancel',
    //               width: 600,
    //               okButtonProps: { size: "large" },
    //               cancelButtonProps: { size: "large" },
    //             });
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];
  console.log('transRecords', transRecords);
  if (!posted) {
    stockTxnsCol.push({
      title: 'Action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DeleteFilled
              style={{
                fontSize: "25px",
                cursor: "pointer",
                color: "#cd1437",
              }}
              onClick={() => {
                Modal.confirm({
                  title: 'Delete Transaction',
                  centered: true,
                  content: `Are you sure you want to delete this transaction?`,
                  onOk: () => deleteTransaction(record.id),
                  okText: 'Delete',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
            />
          </div>
        );
      },
    });
  }
  const resetOrder = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/delete-so`, {
        method: "DELETE",
        body: JSON.stringify({ id: info?.order[0]?.id })

      });
      if (res?.ack) {
        handleSearch();
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch)

    }
  };

  const infoItems = [
    {
      label: 'Customer',
      value: `${recievedData[0]?.customer_code || ''} - ${recievedData[0]?.customer_name || ''}`,
      icon: <UserOutlined style={{ color: "#52c41a" }} />,
      type: 'text',
    },
    {
      label: 'Posting Date',
      value: recievedData[0]?.posting_date
        ? dayjs(recievedData[0]?.posting_date).format('DD-MM-YYYY')
        : '-',
      icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
      type: 'text',
    }
  ]

  const modalInfoItems = [
    {
      label: 'Total Quantity',
      value: `${selectedItem?.fulfilled_quantity || 0}`,
      type: 'text',
      icon: <NumberOutlined style={{ color: "#1677ff" }} />,
      color: '#1677ff',
    },
    {
      label: 'Remaining Quantity',
      value: `${selectedItem?.remaining_quantity || 0}`,
      type: 'text',
      icon: <NumberOutlined style={{ color: "#1677ff" }} />,
      color: selectedItem?.remaining_quantity > 0 ?  'red' : '#1677ff'
    }
  ]

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>Dispatch Stock</h3>
        <AntButton icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</AntButton>
      </div>
      <Flex justify="space-between" align="center" gap={10} style={{ marginBottom: '16px' }} wrap>
        <Flex gap="small">
          <ScanInput onValueChange={handleValueChange} value={soNumber} placeholder={'Invoice Number'} size={'default'} length="100%" autoFocus={true} />
          <AntButton type="primary" onClick={handleSearch}>Search</AntButton>
        </Flex>
        <Flex align="center">
          {
            recievedData?.length > 0 && (
              <CustomTag color={posted ? 'red' : 'orange'} style={{ margin: 0 }}>
                {posted ? 'Dispatched' : 'Pending'}
              </CustomTag>
            )
          }
        </Flex>
      </Flex>

      {
        info?.mismatch && (
          <Alert
            style={{ marginTop: "10px" }}
            banner
            message="Irregularities were detected in this invoice. Please reset it to continue."
            type="warning" showIcon closable
            action={
              <Space>
                <AntButton type="primary" size="small"
                  onClick={() => {
                    Modal.confirm({
                      title: 'Reset Order',
                      centered: true,
                      content: `Are you sure to reset this order? This action cannot be undone.`,
                      onOk: () => resetOrder(),
                      okText: 'Reset',
                      cancelText: 'Cancel',
                      width: 600,
                      okButtonProps: { size: "large" },
                      cancelButtonProps: { size: "large" },
                    });
                  }}
                >
                  Reset Order
                </AntButton>
              </Space>
            }
          />
        )
      }

      <>
        <Box
          sx={{
            marginTop: '15px',
            width: "100%",
            position: "relative",
          }}
        >
          {/* <Grid container rowSpacing={1.5} columnSpacing={{ xs: 2 }}>
            <Grid item xs={12} sm={8} md={5} lg={4} xl={3}>
              <ScanDialog
                label={"Invoice Number"}
                fieldValue={soNumber}
                handleValue={handlePOScanValue}
              />
            </Grid>
            <Grid item xs={12} sm={8} md={6} lg={8} xl={3} sx={{
              "@media (max-width: 960px)": {
                textAlign: "left",
              }
            }}>
              <Button
                variant="contained"

                onClick={() => {
                  handleSearch();
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid> */}
          {/* <Flex justify="end">

            {
              recievedData?.length > 0 && (
                <Tag
                  icon={
                    posted && (
                      <Tooltip title={postedAt ? moment(postedAt).format('DD-MM-YYYY HH:mm:ss') : 'N/A'}>
                        <InfoCircleFilled />
                      </Tooltip>
                    )
                  }
                  style={{ fontSize: '18px', fontWeight: 'bold', padding: 5 }}
                  color={posted ? 'red' : 'warning'}
                >
                  {posted ? 'Dispatched' : 'Pending'}
                </Tag>
              )
            }

          </Flex> */}


          {
            recievedData?.length > 0 && (
              <>
                {/* <InfoCards items={infoItems} /> */}
                <DetailsGrid infoItems={infoItems} />
              </>
            )
          }
          {/* {
            transRecords.length > 0 && (
              <Flex justify="end">
                <AntButton
                  type="primary"
                  style={{ marginLeft: '10px', marginTop: '10px' }}
                  onClick={() => setAllTransactionsModalVisible(true)}
                >
                  View All Transactions
                </AntButton>
              </Flex>

            )
          } */}
          <Box
            sx={{
              marginTop: "20px",
              marginBottom: "30px"
            }}
          >
            <Table
              columns={dataCol}
              dataSource={recievedData}
              pagination={false}
              scroll={{ x: 'max-content' }}
              rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
            />
          </Box>
          {/* <ActionButtons /> */}
        </Box>
        {
          recievedData?.length > 0 && (

            <>
              <Row style={{ marginTop: '5px' }} gutter={[16, 16]}>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <span>
                    Notes:
                  </span>
                  <TextArea
                    value={notes}
                    onChange={(e) => { setNotes(e.target.value) }}
                    placeholder='Please enter any notes.'
                    autoSize={{ minRows: 3, maxRows: 6 }}
                    style={{
                      borderColor: posted === true ? '#1890ff' : undefined,
                      backgroundColor: posted === true ? '#e6f7ff' : undefined,
                      borderWidth: posted === true ? '2px' : undefined,
                    }}
                  />

                </Col>
              </Row>
              <div>
                <UploadButton
                  component="label"
                  variant="contained"
                  sx={{ marginTop: "10px" }}
                  startIcon={<CloudUploadIcon />}
                >
                  Add files
                  <input
                    type="file"
                    hidden
                    multiple
                    capture
                    onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
                    onChange={(e) => {
                      const myfiles = e.target.files;
                      
                      if (myfiles.length > 10) {
                        showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                        e.target.value = "";
                      } else {
                        submitImage(e);
                      }
                    }}
                  />
                </UploadButton>
              </div>

              {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
              <ul>
                {currentItemFiles?.length > 0 &&
                  currentItemFiles
                    .filter(
                      (item) =>
                        !files.some((file) => file.name === item)
                    )
                    .map((item) => {
                      const encodedFileName = item.replace(/\+/g, '%2B');
                      return (
                        <li>
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteCurrentFile(item, deletedFiles, setDeletedFiles, currentItemFiles, setCurrentItemFiles,)}
                          >
                            <DeleteIcon />
                          </IconButton>

                          <a
                            href={`${wms_uploads_cdn}/${env}/dispatch-stock/${soNumber}/${encodedFileName}`}
                            target="_blank"
                          >
                            {extractOriginalFileName(encodedFileName)}
                          </a>
                        </li>
                      );
                    })}
              </ul>

              {files?.length > 0 && <Divider />}

              {files?.length > 0 && <h4>Files:</h4>}
              <ul>
                {files.length > 0 &&
                  files.map((file) => {
                    const encodedFileName = file?.name.replace(/\+/g, '%2B');
                    return (
                      <li>
                        {" "}
                        <IconButton
                          aria-label="delete"
                          color="primary"
                          onClick={() => handleDeleteFile(file?.name, files, currentItemFiles, setFiles, setCurrentItemFiles)}
                        >
                          <DeleteIcon />
                        </IconButton>
                        {extractOriginalFileName(encodedFileName)}
                      </li>
                    );
                  })}
              </ul>
              {files?.length > 0 && <Divider />}
            </>
          )
        }
        {
          recievedData?.length > 0 && (
            <>
              <Flex justify="end" gap={5} style={{ marginTop: "20px" }}>
                <>
                  {!posted && (
                    <>
                      {
                        areAllItemQuantitiesZero ? (
                          <AntButton danger size="large"
                            disabled={posted}
                            onClick={() => {
                              Modal.confirm({
                                title: 'Post Stock',
                                centered: true,
                                content: `Are you sure to post this order? This action cannot be undone.`,
                                onOk: () => postStockData(),
                                okText: 'Post',
                                cancelText: 'Cancel',
                                width: 600,
                                okButtonProps: { size: "large" },
                                cancelButtonProps: { size: "large" },
                              });
                            }}
                          >Post</AntButton>
                        ) : (
                          <AntButton danger size="large"
                            disabled={posted}
                            onClick={() => {
                              Modal.confirm({
                                title: 'Post Stock',
                                centered: true,
                                content: (
                                  <div>
                                    <span><span style={{ color: 'red', marginTop: 8, fontWeight: 400 }}>Some items are not fully dispatched.</span>
                                      {' '}Are you sure you want to post this order? This action cannot be undone.
                                    </span>
                                    {notZeroProductCodes.length > 0 && (
                                      <div style={{ marginBottom: 12 }}>
                                        <div style={{ fontWeight: 500, marginBottom: 4 }}>Pending Product Codes:</div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                          {notZeroProductCodes.map((code, index) => (
                                            <Tag color="volcano" key={index}>
                                              {code?.product_code}
                                            </Tag>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ),
                                onOk: () => postStockData(),
                                okText: 'Post',
                                cancelText: 'Cancel',
                                width: 600,
                                okButtonProps: { size: "large" },
                                cancelButtonProps: { size: "large" },
                              });
                            }}
                          >Post</AntButton>
                        )
                      }
                    </>
                  )}
                </>

                <AntButton size='large' type="primary" onClick={() => saveStockData()}>Save</AntButton>
              </Flex>
            </>

          )
        }

        <Modal width={'70vw'} title={`Dispatch Stock: ${selectedItem?.product_code} - ${selectedItem?.product_name}`} open={modalVisible} onOk={handleModalOk}
          okButtonProps={{ style: { display: 'none' } }}
          onCancel={handleModalCancel} okText="Save"
          cancelButtonProps={{ style: { display: selectedItem?.remaining_quantity >= 1 && 'none' } }}
        >
          <Divider style={{ margin: '10px 0' }} />
          {/* <InfoCards items={modalInfoItems} maxColumns={2} /> */}
          <DetailsGrid infoItems={modalInfoItems} />

          {

            Number(selectedItem?.remaining_quantity) > 0 && !posted && (
              <>
                <Row style={{ marginBottom: "10px" }}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Text>Product</Text>
                    {/* <Flex align="center" gap="small">
                      <ScanInput onValueChange={productValueChange} value={dispatchStock?.product} placeholder="Product" size={'large'} onBlur={productBlur} />
                      <Text type={dispatchStock.productStatus == "error" ? "danger" : dispatchStock.productStatus == "success" ? "success" : ""}>
                        {dispatchStock.productText}
                      </Text>
                    </Flex> */}
                    <ProductScanSelect
                      onValueChange={productSelectValueChange}
                      value={dispatchStock?.product_id}
                      options={products} placeholder="Product"
                      size="large"
                      length={'100%'}
                      productRef={productRef}
                    />
                  </Col>
                </Row>
                {
                  dispatchStock?.product_id > 0 && (
                    <Row style={{ marginBottom: "10px" }}>
                      {/* <Col>
                    <Text>Location</Text>
                    <Flex align="center" gap="small">
                      <ScanInput onValueChange={locationValueChange} value={dispatchStock?.location} placeholder="Location" size={'large'} onBlur={locationBlur} />
                      <Text type={dispatchStock.locationStatus == "error" ? "danger" : dispatchStock.locationStatus == "success" ? "success" : ""}>
                        {dispatchStock.locationText}
                      </Text>
                    </Flex>
                  </Col> */}
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Text>Location</Text>
                        <ScanSelect onValueChange={locationSelectValueChange} value={dispatchStock?.location_id} options={selectedProductLocations} placeholder="Location" size="large" length={'100%'} />
                      </Col>
                    </Row>
                  )
                }


                {
                  dispatchStock?.location_id > 0 && (
                    <Row>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                        <Text>Location Batches</Text>
                        <br />
                        <AntSelect
                          placeholder="Location Batches"
                          size="large"
                          showSearch
                          style={{ width: '100%' }}
                          filterOption={(input, option) =>
                            option?.label?.props?.children
                              ?.map?.((el) => (typeof el === 'string' ? el : ''))
                              .join(' ')
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          value={dispatchStock?.batch_id}
                          onChange={(value) => {
                            const selectedBatch = selectedLocationsBatches?.find((item) => item.batch_id === value);
                            const expiryDate = selectedBatch?.expiry_date ? dayjs(selectedBatch.expiry_date) : null;
                                                            const daysToExpire = expiryDate ? expiryDate.diff(dayjs(), 'day') : null;
                            if (daysToExpire < 0) {
                              Modal.confirm({
                                title: "Expired Batch Selected",
                                content: `The batch you selected expired on ${expiryDate.format(
                                  "DD-MM-YYYY"
                                )}. Do you still want to use it?`,
                                okText: "Yes, Continue",
                                cancelText: "No",
                                onOk: () => {
                                  setDispatchStock({
                              ...dispatchStock,
                              batch_id: value,
                              batch_expiry: selectedBatch?.expiry_date,
                              batch_quantity: selectedBatch?.stock_level,
                              batch_code: selectedBatch?.batch_code,
                              supplier_batch_code: selectedBatch?.supplier_batch_code
                            });
                                },
                              });
                              return;
                            }
                            setDispatchStock({
                              ...dispatchStock,
                              batch_id: value,
                              batch_expiry: selectedBatch?.expiry_date,
                              batch_quantity: selectedBatch?.stock_level,
                              batch_code: selectedBatch?.batch_code,
                              supplier_batch_code: selectedBatch?.supplier_batch_code
                            });
                          }}
                          optionLabelProp="label"
                        >
                          {selectedLocationsBatches.map((item) => {
                            const expiryDate = item?.expiry_date ? dayjs(item.expiry_date) : null;
                            const daysToExpire = expiryDate ? expiryDate.diff(dayjs(), 'day') : null;
                            const isExpired = daysToExpire < 0;
                            const expiryColor =
                              !expiryDate ? 'default' :
                                daysToExpire < 0 ? 'red' :
                                  daysToExpire <= 30 ? 'orange' : 'green';

                            const label = (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Tag color="blue" style={{ margin: 0 }}>Qty: {item?.stock_level}</Tag>
                                <Tag color={expiryColor} style={{ margin: 0 }}>
                                  Exp: {expiryDate ? expiryDate.format('DD-MM-YYYY') : 'N/A'}
                                </Tag>
                              </div>
                            );

                            return (
                              <Option key={item.batch_id} value={item.batch_id} label={label} style={{ padding: 0 }} disabled={isExpired}>
                                <div
                                  style={{
                                    padding: '8px 12px',
                                    margin: '4px 0',
                                    border: '1px solid #f0f0f0',
                                    borderRadius: '8px',
                                    backgroundColor: '#fafafa',
                                  }}
                                >
                                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                    <Tag color="blue" style={{ fontWeight: 'bold', marginRight: 4 }}>
                                      Qty: {item?.stock_level}
                                    </Tag>
                                    <Tag color={expiryColor} style={{ fontSize: '13px', fontWeight: 500 }}>
                                      Exp: {expiryDate ? expiryDate.format('DD-MM-YYYY') : 'N/A'}
                                    </Tag>
                                  </div>
                                  {item?.supplier_batch_code && (
                                    <div style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center' }}>
                                      {/* <BarcodeOutlined style={{ marginRight: 6, fontSize: 13, color: '#999' }} /> */}
                                      Batch Code: <span style={{ fontWeight: 500, marginLeft: 4 }}>{item?.supplier_batch_code}</span>
                                    </div>
                                  )}
                                </div>
                              </Option>
                            );
                          })}
                        </AntSelect>


                      </Col>
                    </Row>
                  )
                }
                {
                  dispatchStock?.batch_id && (
                    <Row style={{ marginTop: 5 }} >
                      <Col>
                        <Text>Quantity</Text>
                        <Flex align="center" gap="small">
                          <Input
                            size="large"
                            type="number"
                            value={dispatchStock?.quantity}
                            placeholder="Quantity"
                            style={{ width: "290px" }}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (e.target.value.includes('.')) return;
                              const qty = Number(val);
                              if (val === "") return setDispatchStock({ ...dispatchStock, quantity: "" });
                              if (!dispatchStock?.product_id) return showMessage("error", "Select product first");
                              if (!dispatchStock?.location_id) return showMessage("error", "Select location first");
                              if (!dispatchStock?.batch_id) return showMessage("error", "Select batch first");
                              if (qty < 0) return showMessage("error", "Quantity cannot be negative");
                              if (qty > Number(dispatchStock?.batch_quantity)) return showMessage("error", "Exceeds batch quantity");
                              if (qty > Number(selectedItem?.fulfilled_quantity)) return showMessage("error", "Exceeds fulfilled quantity");
                              if (qty > Number(selectedItem?.remaining_quantity)) return showMessage("error", "Exceeds remaining quantity");

                              setDispatchStock({ ...dispatchStock, quantity: qty, fullPallet: false });
                            }}
                          />
                          {
                            dispatchStock?.remainQtyShow && (
                              <Checkbox
                                checked={dispatchStock?.remaining_quantity_check}
                                style={{ fontSize: '16px' }}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  const qtyRemaing = selectedItem?.remaining_quantity;

                                  if (isChecked) {
                                    if (!dispatchStock?.product_id) {
                                      showMessage('error', 'Please select a product first');
                                      return;
                                    }
                                    if (!dispatchStock?.location_id) {
                                      showMessage('error', 'Please select a location first ');
                                      return
                                    }
                                    if (!dispatchStock?.batch_id) {
                                      showMessage('error', 'Please select a batch first ');
                                      return
                                    }
                                    if (qtyRemaing > dispatchStock?.batch_quantity) {
                                      showMessage('error', 'remaining quantity exceeding batch quantity')
                                      return
                                    }

                                    setDispatchStock({ ...dispatchStock, quantity: qtyRemaing, remaining_quantity_check: isChecked });
                                  }
                                  else {
                                    setDispatchStock({ ...dispatchStock, quantity: '', remaining_quantity_check: false });
                                  }
                                }}
                              >
                                Remaining Quantity
                              </Checkbox>
                            )
                          }
                          {
                            dispatchStock?.fullPalletShow && (
                              <Checkbox
                                checked={dispatchStock?.fullPallet}
                                size="large"
                                style={{ marginTop: "10px" }}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  if (isChecked) {

                                    if (!dispatchStock?.product_id) return showMessage("error", "Select product first");
                                    if (!dispatchStock?.location_id) return showMessage("error", "Select location first");
                                    if (!dispatchStock?.batch_id) return showMessage("error", "Select batch first");
                                    const selectedProduct = products?.find((pro) => pro?.netsuite_id == dispatchStock?.product_id);
                                    const qtyRemaing = selectedItem?.remaining_quantity;
                                    const fullPalletQty = selectedProduct?.cases_in_pallets;

                                    if (fullPalletQty > Number(dispatchStock?.batch_quantity)) return showMessage("error", "Exceeds batch quantity");
                                    if (fullPalletQty > qtyRemaing) {
                                      showMessage('error', 'Remaining quantity is less than pallet quantity')
                                      return;
                                    } else {
                                      setDispatchStock({ ...dispatchStock, quantity: fullPalletQty, fullPallet: e.target.checked })
                                    }
                                  } else {
                                    setDispatchStock({ ...dispatchStock, quantity: '', fullPallet: false });
                                  }

                                }
                                }
                              >
                                Full Pallet
                              </Checkbox>
                            )
                          }

                        </Flex>


                      </Col>
                    </Row>
                  )
                }


                <Flex justify='end' gap={5}>
                  <AntButton onClick={handleModalCancel}>Cancel</AntButton>
                  <AntButton type='primary' disabled={posted} onClick={handleModalOk}>Save</AntButton>
                </Flex>
                <Divider />
              </>
            )

          }
          {
            stockTransactions?.length > 0 && (
              <>
                {/* <span style={{ fontWeight: 'Bold'}}>Transaction Details</span> */}
                <Table
                  pagination={false}
                  dataSource={stockTransactions}
                  columns={stockTxnsCol}
                  rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                />
                <Divider />
              </>
            )
          }
        </Modal>
        <ProductInfoModal
          visible={modalVisibleProduct}
          onCancel={handleModalCancelProduct}
          selectedItemDetails={selectedProductDetails}
          selectedItems={selectedProductDetails?.productDetails}
        // selectedRecord={selectedRecord}
        />

      </>
    </>
  );
};

export default DispatchStock;
